import qs from 'qs'
import request from '@/utils/request'

// 用户管理接口（/qw-admin/user/*，对应后端 QiWeiAdminController）

// 用户列表（返回全部，不分页）
export function getUserList () {
    return request({
        url: '/qw-admin/user/list',
        method: 'post'
    })
}

// 新增用户：username 必填、realName 可选、password 至少 6 位
export function addUser (data) {
    return request({
        url: '/qw-admin/user/add',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 启用/停用用户：status 1 启用 0 停用（后端限制不能停用自己）
export function updateUserStatus (id, status) {
    return request({
        url: '/qw-admin/user/status',
        method: 'post',
        data: qs.stringify({ id, status })
    })
}
